import React from 'react';

import WpIcon from 'Wpds/components/icon/WpIcon';

import './ConfirmAddSubGoalSection.scss';

type Props = {
  fromTitle: string;
  fromBody: string;
  toTitle: string;
  toBody: string;
  children: React.ReactNode;
};

function ConfirmAddSubGoalSection({ fromTitle, fromBody, toTitle, toBody, children }: Props) {
  return (
    <div className="d-flex flex-column">
      <div className="mb-3">{children}</div>
      <div className="ConfirmAddSubGoalSection d-flex">
        <div className="ConfirmAddSubGoalSection__container d-flex flex-column pr-2">
          <div className="ConfirmAddSubGoalSection__container__title">{fromTitle}</div>
          <div className="ConfirmAddSubGoalSection__container__body">{fromBody}</div>
        </div>
        <div className="ConfirmAddSubGoalSection__arrow d-flex align-items-center px-4">
          <WpIcon name="arrow-right" />
        </div>
        <div className="ConfirmAddSubGoalSection__container d-flex flex-column px-2">
          <div className="ConfirmAddSubGoalSection__container__title">{toTitle}</div>
          <div className="ConfirmAddSubGoalSection__container__body">{toBody}</div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmAddSubGoalSection;
